module.exports = __webpack_public_path__ + "img/3.03befb3b.jpg";